module.exports = __webpack_public_path__ + "img/shop_code.a67dae09.png";